export const BASEURL_API = "https://vjbdhg7j39.execute-api.us-west-2.amazonaws.com/prod";
export const AUTH_API = BASEURL_API + "/auth";
export const DEVICETYPE_API = BASEURL_API + "/devicetype";
// export const GAMES_API = BASEURL_API + "/games";
export const GAMES_BY_DAY = BASEURL_API + "/gamesbyday";
export const HEATMAP_API = BASEURL_API +"/gamesbyday";
export const ANNUALSTATS_API = BASEURL_API +"/getannualstats";
export const NATIONS_API = BASEURL_API +"/getnations";
export const UPDATE_LOGIN_DATE_API = BASEURL_API +"/lastlogin";
